    <template>
        <div class="sw-modal edit-form-component edit-form-component__title">
            <div class="sw-modal-content sw-modal-content--wide">
                <div class="row sw-modal-heading">
                    <div class="col-12">
                        <h4>Heading and Welcome and Thank You messages</h4>
                    </div>
                </div>
                <div class="sw-modal-body">
                    <div class="row question">
                        <div class="col-12 question__question">
                            Header image
                        </div>
                        <div class="col-12">
                            Select one of your uploaded images as the page header for this form.<br/>
                            Go to Configure Establishments -> Appearance in the profile menu.
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Heading <variables v-bind:variables="variablesCopy" v-bind:obj="formTemplate" v-bind:propertyName="'title'" v-bind:inputText="titleInput"></variables>
                        </div>
                        <div class="col-12">
                            <input ref="title" type="text" v-model="formTemplate.title" class="short-question" placeholder="Questions about your stay   ">
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Welcome message
                            <variables v-bind:variables="variablesCopy" v-bind:obj="formTemplate" v-bind:propertyName="'welcomeMessage'" v-bind:inputTextArea="welcomeInput"></variables>
                            <markdown></markdown>
                        </div>
                        <div class="col-12">
                            <textarea ref="welcome" v-model="formTemplate.welcomeMessage" class="long-question"></textarea>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Thank you message
                            <variables v-bind:variables="variablesCopy" v-bind:obj="formTemplate" v-bind:propertyName="'thankYouMessage'" v-bind:inputTextArea="thankYouInput"></variables>
                            <markdown></markdown>
                        </div>
                        <div class="col-12">
                            <textarea ref="thankYou" v-model="formTemplate.thankYouMessage" class="long-question"></textarea>
                        </div>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="updating && !success">
                        <Spinner/>
                    </div>
                    <div class="row" v-show="!updating && !success">
                        <div class="col text-center">
                            <button class="btn btn-secondary" v-on:click="cancel">Cancel</button>
                            <button class="btn btn-primary" v-on:click="save">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

<script>
    import { store } from '../../store.js'
    import Spinner from '../Spinner.vue'
    import Markdown from '../Markdown'
    import Variables from "../establishments/Variables";

    import { variablesMixin } from '../../mixins/VariablesMixin'

    export default {
        name: 'EditTitle',
        components: {
            Spinner, Markdown, Variables
        },
        mixins: [ variablesMixin ],
        props: {
            formTemplate: Object,
            editingThankYou: Boolean
        },
        data: function() {
            return {
                copy: {},
                titleInput: null,
                welcomeInput: null,
                thankYouInput: null,
                updating: false,
                error: false,
                success: false,
                infoMessage: "Info message",
            }
        },
        computed: {
            getTitleInputC: function () {
                if (this.$refs.title) {
                    return this.$refs.title;
                }
                return null;
            },
        },
        methods: {
            cancel: function() {
                console.log("cancel");
                this.formTemplate.title = this.copy.title;
                this.formTemplate.welcomeMessage = this.copy.welcomeMessage;
                this.formTemplate.thankYouMessage = this.copy.thankYouMessage;
                this.$root.$emit('finished-editing-section-or-question');
            },
            save: function() {
                console.log("saving form template");
                this.error = false;

                let body = {
                    "title": this.formTemplate.title,
                    "welcomeMessage": this.formTemplate.welcomeMessage,
                    "thankYouMessage": this.formTemplate.thankYouMessage,
                };

                // updating a form template
                this.updating = true;
                this.infoMessage = "Saving form";
                this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/form-templates/' + this.formTemplate.reference, body
                ).then(response => {
                    console.log("Form updated:")
                    console.log(response);
                    this.infoMessage = "Form updated"
                    this.success = true;
                    setTimeout(() => {
                        this.updating = false;
                        this.$root.$emit('finished-editing-section-or-question');
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.updating = false;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message
                    } else {
                        this.infoMessage = "Error updating form";
                    }
                });
            }
        },
        mounted: async function () {
            this.copy.title = this.formTemplate.title;
            this.copy.welcomeMessage = this.formTemplate.welcomeMessage;
            this.copy.thankYouMessage = this.formTemplate.thankYouMessage;
            this.$nextTick(() => {
                if (this.editingThankYou) {
                    this.$refs.thankYou.focus();
                } else {
                    this.$refs.title.focus();
                }
            });

            this.titleInput = this.$refs.title;
            this.welcomeInput = this.$refs.welcome;
            this.thankYouInput = this.$refs.thankYou;

            await this.fetchVariables();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_form_component";
    @import "../../styles/components/question_answer";
    @import "../../styles/layout/tooltips";
</style>